import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isPaymentPage } from '@/lib/paymentTelemetryPrivacy';
import {
  isPostHogEnabled,
  posthog,
  registerCustomerSurface,
  sessionRecordingOptionsFor,
  unregisterCustomerSurface,
} from '@/lib/posthog';

/**
 * Marks the buyer surface for the current route. Replay stays on everywhere and is masked in the
 * recorder config, so nothing here disables recording: the state follows the route and never
 * latches for the rest of the tab. Replay compression follows the route too, because the send
 * boundary can only redact a snapshot it can still read (see `sessionRecordingOptionsFor`).
 */
export function PaymentPrivacyBoundary() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const customerPage = isPaymentPage(pathname);
    document.body.toggleAttribute('data-payment-private', customerPage);
    if (isPostHogEnabled) {
      posthog.set_config({ session_recording: sessionRecordingOptionsFor(customerPage) });
    }
    if (customerPage) registerCustomerSurface();
    else unregisterCustomerSurface();
    return () => document.body.removeAttribute('data-payment-private');
  }, [pathname]);
  return null;
}
